import { render, staticRenderFns } from "./feedback-tracker-details.vue?vue&type=template&id=33568de4&"
import script from "./js/feedback-tracker-details.js?vue&type=script&lang=js&"
export * from "./js/feedback-tracker-details.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports